import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DividerProps } from './Divider';

interface StyledContainer {
  direction: DividerProps['direction'];
}

interface StyledDividerProps {
  direction: DividerProps['direction'];
  margin: DividerProps['margin'];
  marginTop: DividerProps['marginTop'];
  marginBottom: DividerProps['marginBottom'];
  thickness: DividerProps['thickness'];
}

export const Container = styled.div<StyledContainer>`
  ${({ direction }) => css`
    display: flex;
    align-items: center;

    ${direction === 'vertical' ? { height: '100%' } : { width: '100%' }}
  `}
`;

export const Divider = styled.div<StyledDividerProps>`
  ${({ theme, direction, margin, marginTop, marginBottom, thickness }) => css`
    background: ${theme.backgroundColor.onelevated_divider};
    ${getDirectionStyle(direction, thickness, margin, marginTop, marginBottom)}
  `}
`;

const getDirectionStyle = (
  direction: StyledContainer['direction'] = 'horizontal',
  thickness: StyledDividerProps['thickness'],
  margin = 0,
  marginTop: StyledDividerProps['marginTop'],
  marginBottom: StyledDividerProps['marginBottom'],
) => {
  switch (direction) {
    case 'vertical':
      return css`
        width: ${thickness || 1}px;
        height: 100%;
        margin: 0 ${marginBottom || margin}px 0 ${marginTop || margin}px;
      `;

    case 'horizontal':
    default:
      return css`
        width: 100%;
        height: ${thickness || 1}px;
        margin: ${marginTop || margin}px 0 ${marginBottom || margin}px;
      `;
  }
};
